import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to detect when returning from a form page and trigger refetch
 * @param {Function} refetch - The refetch function to call
 * @param {string} triggerKey - Unique key to identify when to trigger refetch
 */
export const useRefetchOnReturn = (refetch, triggerKey = 'heroSection') => {
  const location = useLocation();

  useEffect(() => {
    // Check if we're returning from an edit/add page
    if (location.state?.shouldRefetch && location.state?.triggerKey === triggerKey) {
      refetch();
      
      // Clear the state to prevent multiple refetches
      window.history.replaceState({}, document.title);
    }
  }, [location, refetch, triggerKey]);
};

/**
 * Hook to set the refetch trigger before navigation
 * @param {Function} navigate - The navigate function
 * @param {string} triggerKey - Unique key to identify when to trigger refetch
 */
export const setRefetchTrigger = (navigate, triggerKey = 'heroSection') => {
  return () => {
    navigate(-1, { state: { shouldRefetch: true, triggerKey } });
  };
};
